import React, { useState } from "react";
import { Input, Form, Col, Row, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommissionsTable from "./CommissionsTable";

// Custom Hooks
import useTableController from "hooks/useTableController";

// Validation
import { CategoryBrandFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import { useGetCommissionsQuery } from "services/commissions/api";
import { useGetFilterOptionsQuery } from "services/filters/api";

const CommissionsTab = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [brandDropdownOpen, setBrandDropdownOpen] = useState(false);

  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange, handleFieldChange } = useTableController({
    initialValues: {
      filterType: "all",
      categoryId: "",
      brandId: "",
    },
    validationSchema: CategoryBrandFilterSchema,
  });

  // State for filter options
  const [options, setOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  // API
  const { data: filterOptionsData } = useGetFilterOptionsQuery();
  const { data, error, isLoading } = useGetCommissionsQuery(formik.values);

  // Get selected option, category and brand based on formik values
  const selectedOption = options.find((o) => o.id === formik.values.filterType) || options[0];
  const selectedCategory = categories.find((c) => c.id === formik.values.categoryId) || categories[0];
  const selectedBrand = brands.find((b) => b.id === formik.values.brandId) || brands[0];

  // Update state when filterOptionsData changes
  React.useEffect(() => {
    if (filterOptionsData) {
      setOptions(filterOptionsData.options || []);
      setCategories(filterOptionsData.categories || []);
      setBrands(filterOptionsData.brands || []);
    }
  }, [filterOptionsData]);

  // ACTIONS
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const toggleCategoryDropdown = () => setCategoryDropdownOpen((prevState) => !prevState);
  const toggleBrandDropdown = () => setBrandDropdownOpen((prevState) => !prevState);

  const handleOptionSelect = (option) => {
    formik.setValues({
      ...formik.values,
      filterType: option.id,
      categoryId: option.id === "category" && categories[0] ? categories[0].id : "",
      brandId: option.id === "brand" && brands[0] ? brands[0].id : "",
    });
  };

  const handleCategorySelect = (category) => {
    formik.setValues({
      ...formik.values,
      categoryId: category.id,
      brandId: "",
    });
    setCategoryDropdownOpen(false);
  };

  const handleBrandSelect = (brand) => {
    formik.setValues({
      ...formik.values,
      brandId: brand.id,
      categoryId: "",
    });
    setBrandDropdownOpen(false);
  };


  // RENDER
  return (
    <Form className="form-horizontal w-100 d-flex flex-column gap-4" onSubmit={formik.handleSubmit} data-testid="search-form">
      <div className="commissions-container" data-testid="tab-commissions">
        <div className="header ">
          <h2 className="fw-semibold">ตั้งค่าเงินค่าคอมมิชชัน</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={5} md={6} lg={3} xl={2}>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>{selectedOption?.name || "เลือกตัวเลือก"}</DropdownToggle>
                  <DropdownMenu>
                    {options.map((option) => (
                      <DropdownItem key={option.id} onClick={() => handleOptionSelect(option)} className={`${formik.values.filterType === option.id ? "active" : ""}`}>
                        {option.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col sm={7} md={6} lg={3} xl={3}>
                {formik.values.filterType === "category" ? (
                  <Dropdown isOpen={categoryDropdownOpen} toggle={toggleCategoryDropdown}>
                    <DropdownToggle caret>{selectedCategory?.name || "เลือกหมวดหมู่"}</DropdownToggle>
                    <DropdownMenu>
                      {categories.map((category) => (
                        <DropdownItem key={category.id} onClick={() => handleCategorySelect(category)} className={`${formik.values.categoryId === category.id ? "active" : ""}`}>
                          {category.name}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                ) : formik.values.filterType === "brand" ? (
                  <Dropdown isOpen={brandDropdownOpen} toggle={toggleBrandDropdown}>
                    <DropdownToggle caret>{selectedBrand?.name || "เลือกแบรนด์"}</DropdownToggle>
                    <DropdownMenu>
                      {brands.map((brand) => (
                        <DropdownItem key={brand.id} onClick={() => handleBrandSelect(brand)} className={`${formik.values.brandId === brand.id ? "active" : ""}`}>
                          {brand.name}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                ) : (
                  <></>
                )}
              </Col>
              <Col sm={12} md={12} lg={6} xl={{ offset: 1, size: 6 }}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input name="searchTerm" type="text" placeholder="ค้นหารายการสินค้า" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} invalid={formik.touched.searchTerm && formik.errors.searchTerm} data-testid="search-input" />
                      {formik.touched.searchTerm && formik.errors.searchTerm && (
                        <div className="error-message" data-testid="search-error">
                          {formik.errors.searchTerm}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <CommissionsTable
          //
          data={data}
          error={error}
          isLoading={isLoading}
          onTableChange={handleTableChange}
        />
      </div>
    </Form>
  );
};

export default CommissionsTab;
